var _circle, _circle2, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5538,
    cy: 21.5616,
    r: 8.88195,
    stroke: "#808080",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5556,
    cy: 25.5556,
    r: 24.0556,
    stroke: "#808080",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1556_39108",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21875 43.3525C9.6119 35.8225 16.9167 30.3438 25.5567 30.3438C34.1957 30.3438 41.4998 35.8211 43.8939 43.3498C39.2496 48.1342 32.7495 51.1072 25.555 51.1072C18.3618 51.1072 11.8628 48.1354 7.21875 43.3525Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 43.3525L4.35967 42.4438L3.81598 44.1545L5.06643 45.4423L7.21875 43.3525ZM43.8939 43.3498L46.0465 45.4393L47.2968 44.1513L46.7528 42.4407L43.8939 43.3498ZM10.0778 44.2611C12.0649 38.0089 18.1892 33.3438 25.5567 33.3438V27.3438C15.6442 27.3438 7.15892 33.636 4.35967 42.4438L10.0778 44.2611ZM25.5567 33.3438C32.9234 33.3438 39.0471 38.0078 41.0349 44.2589L46.7528 42.4407C43.9525 33.6345 35.4681 27.3438 25.5567 27.3438V33.3438ZM41.7412 41.2602C37.6386 45.4867 31.9055 48.1072 25.555 48.1072V54.1072C33.5935 54.1072 40.8606 50.7817 46.0465 45.4393L41.7412 41.2602ZM25.555 48.1072C19.2057 48.1072 13.4736 45.4877 9.37107 41.2626L5.06643 45.4423C10.2521 50.783 17.518 54.1072 25.555 54.1072V48.1072Z",
    fill: "#808080",
    mask: "url(#path-3-inside-1_1556_39108)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.783037776ac341086dbc0c9c4c98a226.svg";
export { ForwardRef as ReactComponent };